import { render, staticRenderFns } from "./case-repayment-statistics.vue?vue&type=template&id=19cd139c&scoped=true"
import script from "./case-repayment-statistics.vue?vue&type=script&lang=ts"
export * from "./case-repayment-statistics.vue?vue&type=script&lang=ts"
import style0 from "./case-repayment-statistics.vue?vue&type=style&index=0&id=19cd139c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd139c",
  null
  
)

export default component.exports